// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routes_root_FpnBA {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: flex-start;
  color: black;
  background: white;
  border-radius: var(--border-radius);
  padding: calc(var(--border-radius) - 12px) var(--border-radius);
  white-space: nowrap;
  overflow: hidden;
  font-size: 28px;
}

.routes_root_FpnBA.routes_simple_cwggi {
  padding: 0.313em 0.45em;
  background: transparent;
  font-size: 22px; /* Same base as timetable standalone font size */
  border-radius: 0;
  overflow: visible;
  justify-content: flex-start;
  color: var(--timetable-text-color);
}

.routes_simple_cwggi .routes_column_wYph2 {
  width: calc(50% + 2em);
  padding-right: 2em;
}

.routes_simple_cwggi .routes_column_wYph2:nth-child(even) {
  width: calc(50% - 2em);
  padding-right: 0;
}

.routes_root_FpnBA.routes_simple_cwggi.routes_a3_dNobw {
  width: auto;
  align-items: center;
  max-width: 750px;
  padding: 0px;
}

.routes_column_wYph2.routes_a3_dNobw {
  width: auto;
  padding-right: 10px;
}

.routes_column_wYph2.routes_a3_dNobw:nth-child(even) {
  padding-right: 0px;
}

.routes_group_lEec3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 84px;
}

.routes_groupA4_nsdHS {
  display: flex;
  flex-direction: column;
  justify-content: left;
  height: 84px;
}

.routes_routeIdsContainer_gemiS {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}

.routes_simple_cwggi .routes_groupA4_nsdHS {
  height: auto;
  margin-top: 0.25rem;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.routes_groupRow_UjwCL {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1 0 auto;
}

.routes_id_a5Kqs {
  padding: 0 12px;
  font-family: GothamXNarrow-Medium;
  font-size: 2.5em;
}

.routes_simple_cwggi .routes_id_a5Kqs {
  font-size: 0.83em;
  padding: 0 0.25em 0 0;
  font-family: GothamXNarrow-Medium;
}

.routes_simple_cwggi .routes_singleId__iOQb {
  font-size: 0.83em;
  padding: 0 0.25em 0 0;
  min-width: 1.875em;
  font-family: GothamXNarrow-Medium;
}

.routes_routeTitles_h330g {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.routes_title_tfRej {
  /* padding-right: 0.893em; */ /* Removed to allow more space for overflow */
  font-family: GothamXNarrow-Medium;
  font-size: 0.83em;
}

.routes_simple_cwggi .routes_title_tfRej {
  padding-right: 0.25em;
}

.routes_subtitle_uRilI {
  font-family: GothamXNarrow-Book;
}

.routes_icon_Tnq07 {
  height: 1em;
  width: 1em;
  font-size: 2.143em;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopPoster/routes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,+DAA+D;EAC/D,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe,EAAE,gDAAgD;EACjE,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4BAA4B,EAAE,6CAA6C;EAC3E,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".root {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: flex-start;\n  color: black;\n  background: white;\n  border-radius: var(--border-radius);\n  padding: calc(var(--border-radius) - 12px) var(--border-radius);\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 28px;\n}\n\n.root.simple {\n  padding: 0.313em 0.45em;\n  background: transparent;\n  font-size: 22px; /* Same base as timetable standalone font size */\n  border-radius: 0;\n  overflow: visible;\n  justify-content: flex-start;\n  color: var(--timetable-text-color);\n}\n\n.simple .column {\n  width: calc(50% + 2em);\n  padding-right: 2em;\n}\n\n.simple .column:nth-child(even) {\n  width: calc(50% - 2em);\n  padding-right: 0;\n}\n\n.root.simple.a3 {\n  width: auto;\n  align-items: center;\n  max-width: 750px;\n  padding: 0px;\n}\n\n.column.a3 {\n  width: auto;\n  padding-right: 10px;\n}\n\n.column.a3:nth-child(even) {\n  padding-right: 0px;\n}\n\n.group {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 84px;\n}\n\n.groupA4 {\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  height: 84px;\n}\n\n.routeIdsContainer {\n  display: flex;\n  justify-content: left;\n  flex-wrap: wrap;\n}\n\n.simple .groupA4 {\n  height: auto;\n  margin-top: 0.25rem;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.groupRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex: 1 0 auto;\n}\n\n.id {\n  padding: 0 12px;\n  font-family: GothamXNarrow-Medium;\n  font-size: 2.5em;\n}\n\n.simple .id {\n  font-size: 0.83em;\n  padding: 0 0.25em 0 0;\n  font-family: GothamXNarrow-Medium;\n}\n\n.simple .singleId {\n  font-size: 0.83em;\n  padding: 0 0.25em 0 0;\n  min-width: 1.875em;\n  font-family: GothamXNarrow-Medium;\n}\n\n.routeTitles {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.title {\n  /* padding-right: 0.893em; */ /* Removed to allow more space for overflow */\n  font-family: GothamXNarrow-Medium;\n  font-size: 0.83em;\n}\n\n.simple .title {\n  padding-right: 0.25em;\n}\n\n.subtitle {\n  composes: title;\n  font-family: GothamXNarrow-Book;\n}\n\n.icon {\n  height: 1em;\n  width: 1em;\n  font-size: 2.143em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `routes_root_FpnBA`,
	"simple": `routes_simple_cwggi`,
	"column": `routes_column_wYph2`,
	"a3": `routes_a3_dNobw`,
	"group": `routes_group_lEec3`,
	"groupA4": `routes_groupA4_nsdHS`,
	"routeIdsContainer": `routes_routeIdsContainer_gemiS`,
	"groupRow": `routes_groupRow_UjwCL`,
	"id": `routes_id_a5Kqs`,
	"singleId": `routes_singleId__iOQb`,
	"routeTitles": `routes_routeTitles_h330g`,
	"title": `routes_title_tfRej`,
	"subtitle": `routes_subtitle_uRilI routes_title_tfRej`,
	"icon": `routes_icon_Tnq07`
};
module.exports = ___CSS_LOADER_EXPORT___;
